const clamp = (min, max, value) => {
  return Math.max(min, Math.min(value, max));
};

const roundDecimal = (value, decimal = 10) => {
  return Math.round(value * decimal) / decimal;
};

export { roundDecimal, clamp };
